import React from 'react';
import img from '../Pages/image/project3.png'

const ThirdProject = () => {
    return (
        <div>
             <section class="text-gray-600 body-font">
        <div class="container mx-auto flex px-5 py-24 md:flex-row flex-col items-center">
      
          <div class="flex flex-col flex-wrap lg:py-6 -mb-10 lg:w-1/2 lg:pl-12 lg:text-left text-center">
            <div class="flex flex-col mb-10 lg:items-start items-center">
              <div class="flex-grow text-left lg:pr-12 lg:px-0 px-5">
                <h1 class="lg:text-6xl text-4xl lg:text-left text-center mb-4 font-bold gradient  ">Web-3 Crypto Tracking Application
                </h1>
                <p class="mb-8 leading-relaxed text-white lg:text-left text-center">Crypto Tracking Application mainly develop to tracking Crypto Current Market Condition.The project developed by Next js, Tailwind</p>
                <div class="flex lg:justify-left ">
                  <button class="inline-flex text-white border-outline border border-0 py-2 px-6 focus:outline-none bg shadow rounded text-lg"><a className='text-white' href='https://github.com/foyjur-192/Crypto-Tracker-application.git' target="_blank" rel='noopener noreferrer'>Github Repo.</a></button>

                </div>
              </div>
            </div>
            <div className='grid grid-rows grid-flow-col mb-5 ' >
              <div className='flex'><input type="checkbox" checked="checked" class="checkbox bg mr-2" /><p className='font-medium text-white text-lg text-left'>Next js</p> </div>
              <div  className='flex'><input type="checkbox" checked="checked" class="checkbox  mr-2" /><p className='font-medium text-white text-lg text-left mb-8'>Tailwind</p> </div>

              </div>
      
            <div><button class="btn btn-outline border hover:bg-cyan-400 mt-5 "><a className='text-white' href='https://crypto-tracker-application.vercel.app/' target="_blank" rel='noopener noreferrer'>Demo</a></button></div>

          </div>
          <div class=" md:w-1/2 lg:mt-0 mt-24 w-full mb-10 md:mb-0">
            <img class="object-cover object-center rounded shadow" alt="hero" src={img} />
          </div>
        </div>
      </section>

        </div>
    );
};

export default ThirdProject;